export const COLUMN_PERSISTENCE_KEY = 'recent-changes-widget-columns';
export const DEFAULT_SORT_FIELD = 'calc_date';
export const DEFAULT_SORT_ORDER = 'desc';
